export default __webpack_public_path__ + "static/media/13.3fa23e08.jpg";